export interface IUpdateTicketRequest  {
    TicketID: number;
    DepartmentID: number;
    UserID: number;
    Subject: string;
    Status: string;
    Name: string;
    CCEmail: string;
    Email: string;
    Priority: string;
    AdminID: number;
    RemoveAdmin: boolean;
    IsMarkdown: boolean;
}

export class UpdateTicketRequest  implements IUpdateTicketRequest {
    TicketID: number;
    DepartmentID: number;
    UserID: number;
    Subject: string;
    Status: string;
    Name: string;
    CCEmail: string;
    Email: string;
    Priority: string;
    AdminID: number;
    RemoveAdmin: boolean;
    IsMarkdown: boolean;
}
